import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Switch,
} from '@material-ui/core';
import Button from 'components/CustomButtons/Button';
import { Settings } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';

class LocalStorageFilterPersistDriver {
  url;

  constructor(url) {
    this.url = url;
  }

  static getAllTablesConfig = () => {
    try {
      return JSON.parse(localStorage.getItem('tables')) || {};
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
    } catch (e) {
      return {};
    }
  };

  getTableConfig = () =>
    LocalStorageFilterPersistDriver.getAllTablesConfig()[this.url] || {};

  setTableConfig = (payload = {}) => {
    localStorage.setItem(
      'tables',
      JSON.stringify({
        ...LocalStorageFilterPersistDriver.getAllTablesConfig(),
        [this.url]: {
          ...this.getTableConfig(),
          ...payload,
        },
      })
    );
  };

  getHiddenColumns = (defaultHiddenColumns = []) =>
    this.getTableConfig(this.url).hiddenColumns || defaultHiddenColumns || [];

  setHiddenColumns = hidden => this.setTableConfig({ hiddenColumns: hidden });
}

export { LocalStorageFilterPersistDriver as FilterPersistDriver };

const useStyles = makeStyles({
  wrapper: {
    transition: '0.5s',
  },
  loading: {
    opacity: 0,
  },
});

const ColumnManager = ({
  columns,
  hidden,
  setHidden,
  isFilterOnHiddenColumn,
  className,
  isLoading = false,
}) => {
  const classes = useStyles();

  const { t } = useTranslation();

  const [isOpen, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const toggleColumn = name => {
    setHidden(
      hidden.includes(name)
        ? hidden.filter(v => v !== name)
        : hidden.concat(name)
    );
  };

  return (
    <>
      <Button
        className={classNames(
          classes.wrapper,
          isLoading && classes.loading,
          className
        )}
        onClick={handleOpen}
        color={isFilterOnHiddenColumn ? 'warning' : 'default'}
        style={{ alignItems: 'end' }}
      >
        <Settings />
        {isFilterOnHiddenColumn && (
          <span>{t('dataGrid.hiddenFiltersUsed')}</span>
        )}
      </Button>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle>{t('dataGrid.visibleColumns')}</DialogTitle>
        <DialogContent>
          <FormGroup>
            {columns.map((c, key) => (
              <FormControlLabel
                key={key}
                label={c.title ? t(c.title) : c.Header}
                control={
                  <Switch
                    checked={!hidden.includes(c.name)}
                    onChange={() => toggleColumn(c.name)}
                  />
                }
              />
            ))}
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('form.close')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ColumnManager;
